import { useEffect, useState } from "react";
import { CardBody, Table, Button, Input, Label } from "reactstrap";
import { Next } from "../../../../Constant";
import { Controller } from "react-hook-form";
import Typeahead from "../../../../CommonElements/TypeAhead";
import { viewAttribute, viewAttributeRole, viewVariant, viewVariantRole } from "../../../../CommonUrl";
import { useSelector } from "react-redux";
import { getClientUrlDataToken } from "../../../../Utils/restUtils";
import { useNavigate } from "react-router";

const ProOptionForm = ({ control, setNextTab, setValue, fields, append, remove }) => {
  const [attributeOption, setAttributeOption] = useState([]);
  const [attributeValueOptions, setAttributeValueOptions] = useState({});
  const authState = useSelector((state) => state.auth);
  const navigate=useNavigate()

  useEffect(() => {
    attributeData();
  }, []);

  const attributeData = async () => {
    const payment = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? viewAttribute : viewAttributeRole);
    if (payment.status === true) {
      const set_payment = payment.data.map((items) => ({ value: items.id, label: items.title }))
      setAttributeOption(set_payment)
    } else if (payment.status >= 400 && payment.status <= 405) {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
    } else if (payment.status >= 500 && payment.status <= 505) {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
    } else {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
    }
  };

  const attributeValueData = async (id, index) => {
    const payment = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? viewVariant + `?attribute_id=${id}` : viewVariantRole + `?attribute_id=${id}`);
    if (payment.status === true) {
      const set_payment = payment.data.map((items) => ({ value: items.id, label: items.value }))
      setAttributeValueOptions((prev) => ({
        ...prev,
        [index]: set_payment,
      }));
    } else if (payment.status >= 400 && payment.status <= 405) {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
    } else if (data.status >= 500 && data.status <= 505) {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
    } else {
      navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
    }
  };

  const handleAddRow = () => {
    append({ attribute: null, attributeValue: null, stock: '', price: '', images: '' });
  };



  const handleRemoveRow = (index) => {
    if (fields.length > 1) {
      remove(index);
    }
  };

  return (
    <CardBody>
      <Table bordered responsive className="mt-3">
        <thead>
          <tr>
            <th>Attribute</th>
            <th>Value</th>
            <th>Stock</th>
            <th>Additional Price</th>
            <th>Images</th>
            <th style={{ width: "100px" }}>Action</th>
          </tr>
        </thead>
        <tbody>
          {fields.map((row, index) => (
            <tr key={row.id}>
              <td className="col-sm-12 col-md-2">
                <Controller
                  name={`rows.${index}.attribute`}
                  control={control}
                  render={({ field }) => (
                    <Typeahead
                      options={attributeOption}
                      onChange={(selected) => {
                        field.onChange(selected);
                        if (selected?.value) {
                          attributeValueData(selected.value, index);
                        }
                        setValue(`rows.${index}.attributValue`, null);
                      }}
                      value={field.value}
                    />
                  )}
                />
              </td>
              <td className="col-sm-12 col-md-2">
                <Controller
                  name={`rows.${index}.attributeValue`}
                  control={control}
                  render={({ field }) => (
                    <Typeahead
                      options={attributeValueOptions[index] || []}
                      onChange={(value) => {
                        field.onChange(value);
                      }}
                      value={field.value}
                    />
                  )}
                />
              </td>
              <td className="col-sm-12 col-md-2">
                <Controller
                  name={`rows.${index}.stock`}
                  control={control}
                  render={({ field }) => (
                    <Input
                      type="number"
                      placeholder="Stock"
                      {...field}
                    />
                  )}
                />
              </td>
              <td className="col-sm-12 col-md-2">
                <Controller
                  name={`rows.${index}.price`}
                  control={control}
                  render={({ field }) => (
                    <Input
                      type="number"
                      placeholder="Additional Price"
                      {...field}
                    />
                  )}
                />
              </td>
              <td className="col-sm-12 col-md-3">
                <Controller
                  name={`rows.${index}.images`}
                  control={control}
                  render={({ field }) => (
                    <Input
                      type="file"
                      onChange={(e) => field.onChange(e.target.files[0])}
                    />
                  )}
                />
              </td>
              <td className="text-center">
                {fields.length > 1 && (
                  <Button color="danger" size="sm" onClick={() => handleRemoveRow(index)}>
                    <i className="fa fa-trash-o"></i>
                  </Button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <div className="d-flex justify-content-between mt-2">
        <Button color="primary" onClick={handleAddRow}>
          + Add
        </Button>
        <Button className="tab-button" onClick={() => setNextTab("3")}>{Next}</Button>
      </div>
    </CardBody>
  );
};

export default ProOptionForm;
